import React from 'react';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function getComponentDisplayName(Component: React.FC<any>): string {
  const displayName = (Component.displayName ?? Component.name) || `Component`;
  return displayName;
}
